var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-login",on:{"click":_vm.onClickToggle}},[_c('div',{class:{ 'toggle-login-bg': true, on: _vm.value }},[_c('div',{class:{ 'toggle-login-switch': true, on: _vm.value }})])])}
var staticRenderFns = []

export { render, staticRenderFns }